import { BaseFetch } from "../main-model";
export default class EmpEvalModel extends BaseFetch {
  getEmpEvalBy = (data) =>
    this.authFetch({
      url: "emp-eval/getEmpEvalBy",
      method: "POST",
      body: data,
    });
  insertEmpEvalByAttendance = (data) =>
    this.authFetch({
      url: "emp-eval/insertEmpEvalByAttendance",
      method: "POST",
      body: data,
    });
  updateEmpEvalByIdAttendance = (data) =>
    this.authFetch({
      url: "emp-eval/updateEmpEvalByIdAttendance",
      method: "POST",
      body: data,
    });
  saveEmpScore = (data) =>
    this.authFetch({
      url: "emp-eval/saveEmpScore",
      method: "POST",
      body: data,
    });
  getEmpEvalByEmployee = (data) =>
    this.authFetch({
      url: "emp-eval/getEmpEvalByEmployee",
      method: "POST",
      body: data,
    });
}
